import { fetcher } from "../../utils/fetcher.js";

export const deleteBoard = (boardId) => {
  return fetcher.delete(`/api/boards/${boardId}`);
};
